/**
 * IconButton Component
 *
 * A button specifically for icon-only interactions.
 */

import React, { forwardRef } from 'react';
import { Icon } from '@iconify/react';
import Spinner from '../Spinner/Spinner';
import './IconButton.css';

const IconButton = forwardRef(({
  icon,
  variant = 'ghost',
  size = 'md',
  disabled = false,
  loading = false,
  label,
  type = 'button',
  className = '',
  ...props
}, ref) => {
  const isDisabled = disabled || loading;

  const classNames = [
    'ds-icon-btn',
    `ds-icon-btn--${variant}`,
    `ds-icon-btn--${size}`,
    loading && 'ds-icon-btn--loading',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      ref={ref}
      type={type}
      className={classNames}
      disabled={isDisabled}
      aria-label={label}
      {...props}
    >
      {loading ? (
        <Spinner size="sm" color="currentColor" />
      ) : typeof icon === 'string' ? (
        <Icon icon={icon} />
      ) : (
        icon
      )}
    </button>
  );
});

IconButton.displayName = 'IconButton';

export default IconButton;
